import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';
import { ApplicantService } from 'src/app/service/applicant.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sign-up-account',
  templateUrl: './sign-up-account.component.html',
  styleUrls: ['./sign-up-account.component.css']
})
export class SignUpAccountComponent  implements OnInit {

  public signUpForm:FormGroup;
  submitted=false;
  showLoadingIndicator: boolean;
  get signUpFormControls() { return this.signUpForm.controls; }

  applicationTypes=[];

  constructor(private fb: FormBuilder,private authService:AuthService
    ,private utilService:UtilService,private applicantService:ApplicantService,
    private router:Router,private toastr: ToastrService) {
  }

  ngOnInit() {

    this.showLoadingIndicator=false;
    this.signUpForm = this.fb.group({
      FullName: ['', [Validators.required]],
      Email: ['',[Validators.required]],
      CountryCode: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(3),
        Validators.pattern(/[0-9]/)]
      ],
      PhoneNumber: ['', [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(10),
        Validators.pattern(/[0-9]/)]
      ],
      ApplicationTypeId: ['', [Validators.required]],
     
    });


    this.utilService.getApplicationTypes().subscribe(data=>{

      this.applicationTypes=data.filter(d=>d.IsForignStudent //&& d.ApplicationTypeId==8
        ).map(item=>{
        return {ApplicationTypeId:item.ApplicationTypeId,Name:item.Name.toUpperCase()};
      });
    });

  }


  onSubmit(){
    this.submitted=true;

    this.showLoadingIndicator=true;
    if(this.signUpForm.valid){

      let model= this.signUpForm.value;
      model.PhoneNumber=model.CountryCode+model.PhoneNumber;
      this.applicantService.generateForignStudentPin(model).subscribe(result=>{
        this.toastr.success('Your Reference # and Pin has been sent to your phone # and Email','Sent');
        this.showLoadingIndicator=false;
      },error=>{
        this.toastr.warning('Sending request failed','Failed');
        this.showLoadingIndicator=false;
        console.log(error);

      });


    }


    
  }
}
